// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"39f70bb5","453":"c02bb138","455":"d78b42f7","977":"a48ca1b7"}[chunkId] + ".chunk.js";
};